import React, { useState, useEffect } from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPIMaturatoSet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localAcceptedFilterModel, setLocalAcceptedFilterModel] = useState();

    const { getComparableTimeframe } = useDates();

    useEffect(() => {
        if (!filterModel) return;
        const localAcceptedFilterModel = { items: [...filterModel.items, { field: "status", operator: "equals", value: "accepted" }] }
        setLocalAcceptedFilterModel(localAcceptedFilterModel);
        setLocalDrawable(true);
    }, [filterModel])



    return (localDrawable &&
        <>
            <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
                <KPI
                    title="Transato"
                    dataProviderName={'statisticsviews/item/sumfinancial/opportunities/proposal/finalValue'}
                    filters={localAcceptedFilterModel}
                    format='currency'
                    compareFilters={
                        {
                            ...getComparableTimeframe(localAcceptedFilterModel, 'registered_at'),
                        }
                    }
                    comparePositiveCondition={'straight'}
                    className='mtska-chart-kpi-short'
                />
                <KPI
                    title="Maturato"
                    dataProviderName={'statisticsviews/item/sumfinancial/opportunities/proposal/totalCommissionValue'}
                    filters={localAcceptedFilterModel}
                    format='currency'
                    compactformat={false}
                    decimaldigits={'standard'}
                    compareFilters={
                        {
                            ...getComparableTimeframe(localAcceptedFilterModel, 'registered_at'),
                        }
                    }
                    comparePositiveCondition={'straight'}
                    className='mtska-chart-kpi-short'
                />
                <KPI
                    title="Maturato Acquisto"
                    dataProviderName={'statisticsviews/item/sumfinancial/opportunities/proposal/buyerCommissionValue'}
                    filters={localAcceptedFilterModel}
                    format='currency'
                    compactformat={false}
                    decimaldigits={'standard'}
                    compareFilters={
                        {
                            ...getComparableTimeframe(localAcceptedFilterModel, 'registered_at'),
                        }
                    }
                    comparePositiveCondition={'straight'}
                    className='mtska-chart-kpi-short'
                />
                <KPI
                    title="Comm. Acq. media"
                    dataProviderName={'statisticsviews/item/avg/opportunities/proposal/buyerCommissionPercentage'}
                    filters={localAcceptedFilterModel}
                    format='percent'
                    compactformat={false}
                    decimaldigits={'standard'}
                    compareFilters={
                        {
                            ...getComparableTimeframe(localAcceptedFilterModel, 'registered_at'),
                        }
                    }
                    comparePositiveCondition={'straight'}
                    className='mtska-chart-kpi-short'
                />
                <KPI
                    title="Maturato Vendita"
                    dataProviderName={'statisticsviews/item/sumfinancial/opportunities/proposal/sellerCommissionValue'}
                    filters={localAcceptedFilterModel}
                    format='currency'
                    compactformat={false}
                    decimaldigits={'standard'}
                    compareFilters={
                        {
                            ...getComparableTimeframe(localAcceptedFilterModel, 'registered_at'),
                        }
                    }
                    comparePositiveCondition={'straight'}
                    className='mtska-chart-kpi-short'
                />
                <KPI
                    title="Comm. Vend. media"
                    dataProviderName={'statisticsviews/item/avg/opportunities/proposal/sellerCommissionPercentage'}
                    filters={localAcceptedFilterModel}
                    format='percent'
                    compareFilters={
                        {
                            ...getComparableTimeframe(localAcceptedFilterModel, 'registered_at'),
                        }
                    }
                    comparePositiveCondition={'straight'}
                    className='mtska-chart-kpi-short'
                />
            </Box>
        </>
    )
}

export default KPIMaturatoSet;